<template>
    <div class="flex items-center pl3">
        <h6>{{rate | toCurrency}}</h6>
        <div class="mh2">/</div>
        <div class="pv3 bodyCopy">{{interval}}</div>
    </div>
</template>

<script>
export default {
    props: {
        rate: {
            type: Number
        },
        hours: {
            type: Number
        }
    },
    computed: {
        interval() {
            if (this.hours == 4) return '4 Hours';
            else if (this.hours == 12) return '12 Hours';
            else if (this.hours == 24) return 'Day';
            else if (this.hours == 72) return '3 Days';
        }
    }
};
</script>
